export default "__VITE_ASSET__6049aee9__"